// import { testing } from '../testing.config'

export const state = () => ({
  include_yoy: false,
  years: [],
  years_all: [],
  year_goal: '2025-2026',
  testing: false,
  authenticated: true,
  full_version: false,
  persistent_variables: {},
  filter_fields_school: [
    { field: 'report_type_label', label: 'Report Type' },
    { field: 'Sector' },
    { field: 'Current Network', label: 'Network' },
    { field: 'School Level', label: 'School Level' },
    { field: 'Admission Type', label: 'Admission Type' },
    { field: 'School Year' },
    //    { field: 'ZIP Code' },
  ],
  showsubgroups: '0',
  showallmetrics: '0',
})

const yearToYearEnd = (year) => parseInt(year.substr(-4))
// const yearToYearShort = year => `${year.substr(0, 4)}-${year.substr(-2)}`
const yearEndToSchoolYear = (yearEnd) =>
  yearEnd ? `${yearEnd - 1}-${yearEnd}` : '-'
const yearEndToSY = (yearEnd) =>
  yearEnd ? `${yearEnd - 1}-${yearEnd - 2000}` : '-'
const yearsToYearEndCurrent = (years) =>
  years
    .map((y) => yearToYearEnd(y))
    .reduce((prev, cur) => Math.max(cur, prev || -Infinity), null)
const yearsToYearEndPrevious = (years) =>
  years
    .map((y) => yearToYearEnd(y))
    .filter((y) => y < yearsToYearEndCurrent(years))
    .reduce((prev, cur) => Math.max(cur, prev || -Infinity), null)
const yearsToYearEndPrevious2 = (years) =>
  years
    .map((y) => yearToYearEnd(y))
    .filter((y) => y < yearsToYearEndPrevious(years))
    .reduce((prev, cur) => Math.max(cur, prev || -Infinity), null)

export const getters = {
  // of the currently available years (determined by filters)
  getSubgroupdisplay: (state) => state.showsubgroups,
  getShowallmetrics: (state) => state.showallmetrics,
  yearend_g: (state) => yearToYearEnd(state.year_goal),
  yearend_c: (state) => yearsToYearEndCurrent(state.years),
  yearend_p: (state) => yearsToYearEndPrevious(state.years),
  yearend_p2: (state) => yearsToYearEndPrevious2(state.years),
  schoolyear_c: (state) =>
    yearEndToSchoolYear(yearsToYearEndCurrent(state.years)),
  schoolyear_p: (state) =>
    yearEndToSchoolYear(yearsToYearEndPrevious(state.years)),
  schoolyear_p2: (state) =>
    yearEndToSchoolYear(yearsToYearEndPrevious2(state.years)),
  sy_g: (state) => yearEndToSY(yearToYearEnd(state.year_goal)),
  sy_c: (state) => yearEndToSY(yearsToYearEndCurrent(state.years)),
  sy_p: (state) => yearEndToSY(yearsToYearEndPrevious(state.years)),
  sy_p2: (state) => yearEndToSY(yearsToYearEndPrevious2(state.years)),

  // of all possible years
  yearend_c_all: (state) => yearsToYearEndCurrent(state.years_all),
  yearend_p_all: (state) => yearsToYearEndPrevious(state.years_all),
  yearend_p2_all: (state) => yearsToYearEndPrevious2(state.years_all),
  schoolyear_c_all: (state) =>
    yearEndToSchoolYear(yearsToYearEndCurrent(state.years_all)),
  schoolyear_p_all: (state) =>
    yearEndToSchoolYear(yearsToYearEndPrevious(state.years_all)),
  schoolyear_p2_all: (state) =>
    yearEndToSchoolYear(yearsToYearEndPrevious2(state.years_all)),
  sy_c_all: (state) => yearEndToSY(yearsToYearEndCurrent(state.years_all)),
  sy_p_all: (state) => yearEndToSY(yearsToYearEndPrevious(state.years_all)),
  sy_p2_all: (state) => yearEndToSY(yearsToYearEndPrevious2(state.years_all)),
}

export const mutations = {
  set_testing(state, val) {
    state.testing = val
  },
  set_authenticated(state, val) {
    state.authenticated = val
  },
  set_years(state, val) {
    state.years = val
  },
  set_years_all(state, val) {
    state.years_all = val
  },
  set_persistent_variable(state, { key, value }) {
    state.persistent_variables[key] = value
  },
  set_subgroup(state, val) {
    state.showsubgroups = val
  },
  set_showallmetrics(state, val) {
    state.showallmetrics = val
  },
}

export const actions = {
  /* 
  initialize({ commit }) {
    commit('set_testing', testing || false)
    if (testing) {
      const cookie = this.$cookies.get('spree-test-authentication')
      commit('set_authenticated', !!cookie)
    }
  },
*/
  set_authenticated({ commit }, value) {
    commit('set_authenticated', value)
    this.$cookies.set('spree-test-authentication', value, {
      maxAge: 60 * 60 * 24 * 7,
    })
  },

  set_years({ state, commit }, values) {
    let years
    // if there are no values for year we reset to all
    if (values.Year) {
      years = values.SchoolYear.map(({ text }) => text)
    } else {
      years = state.years_all
    }
    commit('set_years', years)
  },
  set_years_all({ commit }, values) {
    const years = values.SchoolYear.map(({ text }) => text)
    commit('set_years_all', years)
    // since the currently available years must be a subset of all years set these
    commit('set_years', years)
  },
  set_persistent_variable({ commit }, { key, value }) {
    commit('set_metric_code', { key, value })
  },
  set_subgroup_value({ state, commit }) {
    const payload = state.showsubgroups === '0' ? '1' : '0'
    commit('set_subgroup', payload)
  },
  set_showallmetrics_value({ state, commit }) {
    const payload = state.showallmetrics === '0' ? '1' : '0'
    commit('set_showallmetrics', payload)
  },
}
